<div class="modal-content" *ngIf="loaded">
  <div class="modal-header text-center p-3">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <h4 class="modal-title w-100">{{ 'baryApp.quotations.customerModal.title' | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div *ngIf="!isInvalid()" class="col-12">
        <p jhiTranslate="baryApp.quotations.customerModal.text1">
          Les équipes commerciales du transporteur vous ont fait la proposition suivante, que vous pouvez accepter et ajouter à votre panier
        </p>
        <p jhiTranslate="baryApp.quotations.customerModal.text2">Vous pouvez également la refuser et dans ce cas ce vous la retrouverez dans vos anciens devis</p>
        <table *ngIf="estimation && (estimation?.errorMessages)!.length > 0" mdbTable class="w-100 table table-striped table-hover table-sm text-center">
          <thead>
            <tr>
              <th class="text-center tab-title">Expédition</th>
              <th class="text-center tab-title">Livraison</th>
              <th class="text-center tab-title-right">Prix HT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="quotation">
              <td>{{ quotation.pickupDate?.toDate() | date: 'shortDate' }}</td>
              <td>{{ quotation.deliveryDate?.toDate() | date: 'shortDate' }}</td>
              <td>{{ quotation.quotationBasePrice | currency: 'EUR' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="aside-sticky-container p-3" *ngIf="estimation && (estimation?.errorMessages)!.length == 0">
          <jhi-estimation-price [showButton]="false" [lastEstimate]="estimation"></jhi-estimation-price>
        </div>
      </div>
    </div>
    <div *ngIf="isInvalid()" class="alert alert-warning text-center">
      {{ 'LABEL.ERROR_EXPIRED_QUOTATION' | translate }}
    </div>
    <div *ngIf="!isInvalid()" class="text-center mt-3">
      <jhi-bary-button color="danger" class="ml-2" [label]="'baryApp.quotations.customerModal.deny' | translate" (click)="handleClick({ second: true })"></jhi-bary-button>
      <jhi-bary-button color="success" data-id-cypress="valider-user-quotation" [label]="'baryApp.quotations.customerModal.send' | translate" (click)="submit()"></jhi-bary-button>
    </div>
  </div>
</div>
